import { defineMessage } from '@lingui/macro';

const SUPER_ADMIN = 'SUPER_ADMIN',
  SUPERINTENDENT = 'SUPERINTENDENT',
  FIELD_ENGINEER = 'FIELD_ENGINEER',
  FOREMAN = 'FOREMAN',
  GENERAL_FOREMAN = 'GENERAL_FOREMAN',
  PROJECT_ADMIN = 'PROJECT_ADMIN',
  SUPER_USER = 'SUPER_USER',
  ROD_ROOM_ATTENDANT = 'ROD_ROOM_ATTENDANT';

export const PersonaMessages = {
  [SUPER_ADMIN]: defineMessage({ message: `Super Admin` }),
  [SUPERINTENDENT]: defineMessage({ message: `Superintendent` }),
  [FIELD_ENGINEER]: defineMessage({ message: `Field Engineer` }),
  [FOREMAN]: defineMessage({ message: `Foreman` }),
  [GENERAL_FOREMAN]: defineMessage({ message: `General Foreman` }),
  [PROJECT_ADMIN]: defineMessage({ message: `Project Admin` }),
  [SUPER_USER]: defineMessage({ message: `Super User` }),
  [ROD_ROOM_ATTENDANT]: defineMessage({ message: `Rod Room Attendant` }),
};
